import { NavBar } from './parts/nav'
import { scrollTopButton } from './parts/scroll-to-top'
import { landingPage } from './parts/landing-page'

let scrollTop = document.querySelector('.cd-top')
scrollTop instanceof HTMLElement && scrollTopButton(scrollTop)

let nav = document.querySelector('.menu')
nav instanceof HTMLElement && new NavBar(nav)

landingPage()
